import { InputText, Modal } from "src/components";
import { Grid, Button, Typography, Box } from "@material-ui/core";
import NumberFormat from "react-number-format";
import _ from "lodash";
import { Cancel as CancelIcon } from "@material-ui/icons";

import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";
dayjs.extend(utc);

function ModalCliente({ open, close, data }) {
  function rowMaskCPF(cpf_cnpj) {
    return _.join(
      _.map(cpf_cnpj, (item, index) => (index > 2 && index < 8 ? "*" : item)),
      ""
    );
  }

  return (
    <Modal open={open} width={650}>
      <Grid container sm={12}>
        <Grid item sm={12}>
          <Typography> Dados do cliente </Typography>
        </Grid>
        <Grid container sm={12} spacing={1}>
          <Grid item sm={2}>
            <InputText disabled label="ID" value={data.cliente_id} />
          </Grid>
          <Grid item sm={10}>
            <InputText disabled label="Nome" value={data.cliente_nome} />
          </Grid>
        </Grid>
        <Grid container sm={12} spacing={1}>
          <Grid item sm={4}>
            <InputText
              disabled
              label="CPF"
              value={rowMaskCPF(data.cliente_cpf)}
            />
          </Grid>
          <Grid item sm={3}>
            <NumberFormat
              disabled
              label="CEP"
              value={data.cep}
              format="#####-###"
              customInput={InputText}
            />
          </Grid>
          <Grid item sm={5}>
            <InputText disabled label="Bairro" value={data.bairro} />
          </Grid>
        </Grid>
        <Grid container sm={12} spacing={1}>
          <Grid item sm={6}>
            <InputText disabled label="Cidade" value={data.cidade} />
          </Grid>
          <Grid item sm={2}>
            <InputText disabled label="UF" value={data.uf} />
          </Grid>
          <Grid item sm={4}>
            <InputText disabled label="Distancia" value={data.Bairro} />
          </Grid>
        </Grid>
      </Grid>
      <Box
        marginTop="8px"
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Button
          color="secondary"
          size="small"
          onClick={() => close({ cliente: false })}
        >
          {<CancelIcon />}&nbsp;Cancelar
        </Button>
      </Box>
    </Modal>
  );
}

export default ModalCliente;
